/* global tableau */
document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('.wp-block-embed-tableau'))
    .forEach((embed) => {
      const {
        dataset: {
          url = '',
        } = {},
      } = embed;
      if (url) {
        // Tableau initialization only works with the `new` keyword.
        new tableau.Viz(embed, url); // eslint-disable-line no-new
      }
    });
});
